// extracted by mini-css-extract-plugin
module.exports = {"total":"JuhePayPage_total__3nJE2","content":"JuhePayPage_content__cD7vr"};